<template>
  <v-dialog
    v-model="isOpened"
    persistent
    width="480px"
  >
    <v-card>
      <v-card-title>
        Choix du type de client
        <v-spacer></v-spacer>
        <v-btn icon @click="isOpened = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8">
        <v-row no-gutters justify="center" align="center">
          <v-col>
            <n-card clickable class="mr-2 py-6 text-center" @click="$canWrite && (submit(`maker`))">
              Prestataire
            </n-card>
          </v-col>
          <v-col>
            <n-card clickable class="ml-2 py-6 text-center" @click="$canWrite && (submit(`aggregator`))">
              Donneur d'ordres
            </n-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: [`value`],
  computed: {
    isOpened: {
      get() { return this.value; },
      set(isOpened) { this.$emit(`input`, isOpened); },
    },
  },
  methods: {
    initLocalState() {},
    async submit(type) {
      this.$emit(`choosen`, type);
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initLocalState();
      }
    },
  },
};
</script>
